const eventTypeEnum = {
    message: 'message',

}

export default eventTypeEnum;